<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="p-2">
      <small class="text-muted">Report Income</small>
  </h3>
  <div class="p-2 dropdown-divider"></div>
  <div class="row">
    <div class="form-group col-3">
      <label for="subject">Start Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportIncome.startDate" ></flat-pickr>
    </div>
    <div class="form-group col-3">
      <label for="subject">To Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportIncome.toDate"></flat-pickr>
    </div>
    <div class="form-group col-3">
    <label for="uom">Doctor</label>
    <app-lookup-field :model="reportIncome" :element="doctorLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
  </div>
  </div>
  <br /><br />
  <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
  <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportIncome } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportIncome: {...reportIncome},
        role: 'doctor',
        doctorLookup: {
          id: 'doctor-lookup',
          title: 'Handled By',
          byParams: true,
          type: 'form',
          apiUrl: 'member-management-list-by-role',
          filter: ['memberName'],
          params: [
            {
              key: 'role',
              value: 'role',
            }
          ],
          fields: [
            {
              placeholder: 'Doctor Name',
              width: 12,
              column: 'memberName'
            }
          ],
          dtElements: [
            {
              title: 'Doctor Name',
              column: 'memberName'
            },
          ],
          affectedField: [
            {
              from: 'id',
              to: 'memberId'
            },
            {
              from: 'memberName',
              to: 'memberName'
            },
          ]
        },
      }
    },
    async created() {

    },
    methods: {
    async print() {
      const rptApi = api('print/report-income')
      const query = { 
        params: {
          startDate: this.reportIncome.startDate,
          toDate: this.reportIncome.toDate,
          memberId: this.reportIncome.memberId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Income.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentIncome = this.reportIncome
      this.reportIncome = {
          ...currentIncome,
          ...data
      }
    },
    finishUpload(data) {
      const currentIncome = this.reportIncome
      this.reportIncome = {
        ...currentIncome,
        ...data
      }
    },
    }
}
</script>